import { render, staticRenderFns } from "./depositRequestModal.vue?vue&type=template&id=1fa84c0a&scoped=true"
import script from "./depositRequestModal.vue?vue&type=script&lang=js"
export * from "./depositRequestModal.vue?vue&type=script&lang=js"
import style0 from "./depositRequestModal.vue?vue&type=style&index=0&id=1fa84c0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa84c0a",
  null
  
)

export default component.exports